(function () {
  /**
   * @ngdoc constant
   * @name interceptor constants
   * @description defines interceptor constants
   */
  angular
    .module('app.core.api.interceptor')
    .constant('CACHE_IS_COLD', 'CACHE_IS_COLD')
    .constant('MAX_CACHE_IS_COLD_RETRIES', 5);
})();
